import React from "react";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import ContinueButton from "canvas-core-react/lib/ContinueButton";
import BackButton from "canvas-core-react/lib/BackButton";

const BackContinue = ({goBack, canContinue, handleContinue, isLoading}) => {
    return (
        <Row justifyContent="center">
            <Column md={11} lg={11} sm={7} xs={4}>
                <div className="backContContainer">
                    <BackButton
                        type="back"
                        onClick={goBack}
                        disabled={true}
                        id={"navigation-volver-button"}
                    >
                        {"Volver"}
                    </BackButton>
                    <ContinueButton
                        loading={isLoading}
                        type="continue"
                        onClick={handleContinue}
                        disabled={!canContinue}
                        id={"navigation-continuar-button"}
                    >
                        {"Continuar"}
                    </ContinueButton>
                </div>
            </Column>
        </Row>
    );
};

export default BackContinue;
